// @Version: 1.0.3
import { Component, Input, OnChanges, OnDestroy, SimpleChanges, forwardRef } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ErrorMessagesService } from 'src/app/shared/services/errorMessages/error-messages.service';
import { IFieldItem, ROWPOSITION } from '../field-item.model';
import { FieldItemService } from '../field-item.service';
import { IImageImgText, ILinkImgText, IMGPOS, IMGSIZE } from './img-text.model';
import { ImgTextService } from './img-text.service';
import { FIELDWIDTH } from 'src/app/project/components/field-item-row/row.model';

@UntilDestroy()
@Component({
  selector: 'app-field-item-img-text',
  templateUrl: './img-text.component.html',
  providers: [
     {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FieldItemImgTextComponent),
        multi: true
     },
     {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => FieldItemImgTextComponent),
        multi: true
     },
     ErrorMessagesService
  ],
  standalone: false
})
export class FieldItemImgTextComponent implements ControlValueAccessor, OnDestroy, OnChanges {
  public IMGPOS = IMGPOS;
  public IMGSIZE = IMGSIZE;
  public FIELDWIDTH = FIELDWIDTH;
  public ROWPOSITION = ROWPOSITION;
  public image: IImageImgText = {} as IImageImgText;
  public link: ILinkImgText = {} as ILinkImgText;

  private fieldItem_: IFieldItem = {} as IFieldItem;
  private maxWidth_: string = FIELDWIDTH.MAX;
  private minWidth_: string = FIELDWIDTH.MIN;

  @Input() 
  get fieldItem (): IFieldItem {
    return this.fieldItem_;
  }
  set fieldItem (value: IFieldItem) {
    this.fieldItem_ = value || {};
  }

  @Input()
  get maxWidth (): string {
    return this.maxWidth_;
  }
  set maxWidth (max: string) {
    this.maxWidth_ = max;
  }

  @Input()
  get minWidth (): string {
    return this.minWidth_;
  }
  set minWidth (min: string) {
    this.minWidth_ = min;
  }

  constructor (public sFieldItem: FieldItemService, public sImgTextService: ImgTextService) { }
  ngOnChanges(changes: SimpleChanges): void {
     if (changes && changes.fieldItem &&  (JSON.stringify(changes.fieldItem.currentValue) != JSON.stringify(changes.fieldItem.previousValue))) {
        changes.fieldItem.currentValue.attribute_6 && changes.fieldItem.currentValue.attribute_6.indexOf(";") > -1 ? this.image = this.sImgTextService.setImgText(changes.fieldItem.currentValue.attribute_6!) : this.image.altText = changes.fieldItem.currentValue.attribute_6!;
        if (changes.fieldItem.currentValue.attribute_4 && changes.fieldItem.currentValue.attribute_4 != '') this.link = this.sImgTextService.setLink(changes.fieldItem.currentValue.attribute_4!);
     }
  }

  ngOnDestroy (): void {
     this.fieldItem_= {} as IFieldItem;
  }

  validate (control: AbstractControl): ValidationErrors | null {
     return null;
  }

  writeValue (obj: any): void {
  }

  registerOnChange (fn: any): void { 
  }

  registerOnTouched (fn: any): void {  
  }

  setDisabledState (isDisabled: boolean | undefined): void {}
   
  private onTouched () {}

  private onChange (_: string) {}
}
